function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _get() { if (typeof Reflect !== "undefined" && Reflect.get) { _get = Reflect.get; } else { _get = function _get(target, property, receiver) { var base = _superPropBase(target, property); if (!base) return; var desc = Object.getOwnPropertyDescriptor(base, property); if (desc.get) { return desc.get.call(arguments.length < 3 ? target : receiver); } return desc.value; }; } return _get.apply(this, arguments); }

function _superPropBase(object, property) { while (!Object.prototype.hasOwnProperty.call(object, property)) { object = _getPrototypeOf(object); if (object === null) break; } return object; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

/**
 * @license
 * Copyright (c) 2021 - 2023 Vaadin Ltd.
 * This program is available under Apache License Version 2.0, available at https://vaadin.com/license/
 */
import { DelegateFocusMixin } from '@vaadin/a11y-base/src/delegate-focus-mixin.js';
import { KeyboardMixin } from '@vaadin/a11y-base/src/keyboard-mixin.js';
import { timeOut } from '@vaadin/component-base/src/async.js';
import { Debouncer } from '@vaadin/component-base/src/debounce.js';
import { SlotStylesMixin } from '@vaadin/component-base/src/slot-styles-mixin.js';
import { ClearButtonMixin } from './clear-button-mixin.js';
import { FieldMixin } from './field-mixin.js';
import { InputConstraintsMixin } from './input-constraints-mixin.js';
/**
 * A mixin to provide shared logic for the editable form input controls.
 *
 * @polymerMixin
 * @mixes DelegateFocusMixin
 * @mixes FieldMixin
 * @mixes InputConstraintsMixin
 * @mixes KeyboardMixin
 * @mixes ClearButtonMixin
 * @mixes SlotStylesMixin
 */

export var InputControlMixin = function InputControlMixin(superclass) {
  return /*#__PURE__*/function (_SlotStylesMixin) {
    _inherits(InputControlMixinClass, _SlotStylesMixin);

    var _super = _createSuper(InputControlMixinClass);

    function InputControlMixinClass() {
      var _this;

      _classCallCheck(this, InputControlMixinClass);

      _this = _super.call(this);
      _this._boundOnPaste = _this._onPaste.bind(_assertThisInitialized(_this));
      _this._boundOnDrop = _this._onDrop.bind(_assertThisInitialized(_this));
      _this._boundOnBeforeInput = _this._onBeforeInput.bind(_assertThisInitialized(_this));
      return _this;
    }
    /** @protected */


    _createClass(InputControlMixinClass, [{
      key: "slotStyles",
      get: function get() {
        // Needed for Safari, where ::slotted(...)::placeholder does not work
        return ["\n          :is(input[slot='input'], textarea[slot='textarea'])::placeholder {\n            font: inherit;\n            color: inherit;\n          }\n        "];
      }
      /**
       * Override an event listener from `DelegateFocusMixin`.
       * @param {FocusEvent} event
       * @protected
       * @override
       */

    }, {
      key: "_onFocus",
      value: function _onFocus(event) {
        _get(_getPrototypeOf(InputControlMixinClass.prototype), "_onFocus", this).call(this, event);

        if (this.autoselect && this.inputElement) {
          this.inputElement.select();
        }
      }
      /**
       * Override an event listener inherited from `InputMixin`
       * to capture native `change` event and make sure that
       * a new one is dispatched after validation runs.
       * @param {Event} event
       * @protected
       * @override
       */

    }, {
      key: "_onChange",
      value: function _onChange(event) {
        event.stopPropagation();
        this.validate();
        this.dispatchEvent(new CustomEvent('change', {
          detail: {
            sourceEvent: event
          },
          bubbles: event.bubbles,
          cancelable: event.cancelable
        }));
      }
      /**
       * Override a method from `InputMixin`.
       * @param {!HTMLElement} input
       * @protected
       * @override
       */

    }, {
      key: "_addInputListeners",
      value: function _addInputListeners(input) {
        _get(_getPrototypeOf(InputControlMixinClass.prototype), "_addInputListeners", this).call(this, input);

        input.addEventListener('paste', this._boundOnPaste);
        input.addEventListener('drop', this._boundOnDrop);
        input.addEventListener('beforeinput', this._boundOnBeforeInput);
      }
      /**
       * Override a method from `InputMixin`.
       * @param {!HTMLElement} input
       * @protected
       * @override
       */

    }, {
      key: "_removeInputListeners",
      value: function _removeInputListeners(input) {
        _get(_getPrototypeOf(InputControlMixinClass.prototype), "_removeInputListeners", this).call(this, input);

        input.removeEventListener('paste', this._boundOnPaste);
        input.removeEventListener('drop', this._boundOnDrop);
        input.removeEventListener('beforeinput', this._boundOnBeforeInput);
      }
      /**
       * Override an event listener from `KeyboardMixin`.
       * @param {!KeyboardEvent} event
       * @protected
       * @override
       */

    }, {
      key: "_onKeyDown",
      value: function _onKeyDown(event) {
        _get(_getPrototypeOf(InputControlMixinClass.prototype), "_onKeyDown", this).call(this, event);

        if (this.allowedCharPattern && !this.__shouldAcceptKey(event)) {
          event.preventDefault();

          this._markInputPrevented();
        }
      }
      /** @protected */

    }, {
      key: "_markInputPrevented",
      value: function _markInputPrevented() {
        var _this2 = this;

        // Add input-prevented attribute for 200ms
        this.setAttribute('input-prevented', '');
        this._preventInputDebouncer = Debouncer.debounce(this._preventInputDebouncer, timeOut.after(200), function () {
          _this2.removeAttribute('input-prevented');
        });
      }
      /** @private */

    }, {
      key: "__shouldAcceptKey",
      value: function __shouldAcceptKey(event) {
        return event.metaKey || event.ctrlKey || !event.key || // Allow typing anything if event.key is not supported
        event.key.length !== 1 || // Allow "Backspace", "ArrowLeft" etc.
        this.__allowedCharRegExp.test(event.key);
      }
      /** @private */

    }, {
      key: "_onPaste",
      value: function _onPaste(e) {
        if (this.allowedCharPattern) {
          var pastedText = e.clipboardData.getData('text');

          if (!this.__allowedTextRegExp.test(pastedText)) {
            e.preventDefault();

            this._markInputPrevented();
          }
        }
      }
      /** @private */

    }, {
      key: "_onDrop",
      value: function _onDrop(e) {
        if (this.allowedCharPattern) {
          var draggedText = e.dataTransfer.getData('text');

          if (!this.__allowedTextRegExp.test(draggedText)) {
            e.preventDefault();

            this._markInputPrevented();
          }
        }
      }
      /** @private */

    }, {
      key: "_onBeforeInput",
      value: function _onBeforeInput(e) {
        // The `beforeinput` event covers all the cases for `allowedCharPattern`: keyboard, pasting and dropping,
        // but it is still experimental technology so we can't rely on it. It's used here just as an additional check,
        // because it seems to be the only way to detect and prevent specific keys on mobile devices.
        // See https://github.com/vaadin/vaadin-text-field/issues/429
        if (this.allowedCharPattern && e.data && !this.__allowedTextRegExp.test(e.data)) {
          e.preventDefault();

          this._markInputPrevented();
        }
      }
      /** @private */

    }, {
      key: "_allowedCharPatternChanged",
      value: function _allowedCharPatternChanged(charPattern) {
        if (charPattern) {
          try {
            this.__allowedCharRegExp = new RegExp("^".concat(charPattern, "$"), 'u');
            this.__allowedTextRegExp = new RegExp("^".concat(charPattern, "*$"), 'u');
          } catch (e) {
            console.error(e);
          }
        }
      }
      /**
       * Fired when the user commits a value change.
       *
       * @event change
       */

      /**
       * Fired when the value is changed by the user: on every typing keystroke,
       * and the value is cleared using the clear button.
       *
       * @event input
       */

    }], [{
      key: "properties",
      get: function get() {
        return {
          /**
           * A pattern matched against individual characters the user inputs.
           *
           * When set, the field will prevent:
           * - `keydown` events if the entered key doesn't match `/^allowedCharPattern$/`
           * - `paste` events if the pasted text doesn't match `/^allowedCharPattern*$/`
           * - `drop` events if the dropped text doesn't match `/^allowedCharPattern*$/`
           *
           * For example, to allow entering only numbers and minus signs, use:
           * `allowedCharPattern = "[\\d-]"`
           * @attr {string} allowed-char-pattern
           */
          allowedCharPattern: {
            type: String,
            observer: '_allowedCharPatternChanged'
          },

          /**
           * If true, the input text gets fully selected when the field is focused using click or touch / tap.
           */
          autoselect: {
            type: Boolean,
            value: false
          },

          /**
           * The name of this field.
           */
          name: {
            type: String,
            reflectToAttribute: true
          },

          /**
           * A hint to the user of what can be entered in the field.
           */
          placeholder: {
            type: String,
            reflectToAttribute: true
          },

          /**
           * When present, it specifies that the field is read-only.
           */
          readonly: {
            type: Boolean,
            value: false,
            reflectToAttribute: true
          },

          /**
           * The text usually displayed in a tooltip popup when the mouse is over the field.
           */
          title: {
            type: String,
            reflectToAttribute: true
          }
        };
      }
    }, {
      key: "delegateAttrs",
      get: function get() {
        return [].concat(_toConsumableArray(_get(_getPrototypeOf(InputControlMixinClass), "delegateAttrs", this)), ['name', 'type', 'placeholder', 'readonly', 'invalid', 'title']);
      }
    }]);

    return InputControlMixinClass;
  }(SlotStylesMixin(DelegateFocusMixin(InputConstraintsMixin(FieldMixin(ClearButtonMixin(KeyboardMixin(superclass)))))));
};